import { FC } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { DateRange } from '@servicetitan/application-data/marketing';
import { Perform } from './perform';

interface PerformDateRangeProps {
    name: string;
    value?: DateRange | undefined;
}

function getFormatDate(date: Date) {
    return moment(date).format('MM/DD/YY');
}

export const PerformDateRange: FC<PerformDateRangeProps> = observer(
    ({ value, name }: PerformDateRangeProps) => {
        const text = !value
            ? ''
            : `${value.from ? getFormatDate(value.from) : ''}${
                  value.to ? ' to ' + getFormatDate(value.to) : ''
              }`;
        return <Perform name={name} text={text} />;
    }
);
